<div class="icons flex-centered">
  <div *ngIf="leftVisible" class="selection flex-centered" (click)="onLeftSelected.emit()">
    <i [ngClass]="leftIcon"></i>
    <div>{{ leftText }}</div>
  </div>

  <div *ngIf="leftVisible && rightVisible" class="vrule"></div>

  <div *ngIf="rightVisible" class="selection flex-centered" (click)="onRightSelected.emit()">
    <i [ngClass]="rightIcon"></i>
    <div>{{ rightText }}</div>
  </div>
</div>
